import React from 'react';
import Icon from './Icon';
import Button from './Button';
import Modal from './Modal';
import './ui.css';

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmar',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  loading = false,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    footer={
      <>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant="primary" onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <div className="pn-modal__body--center">
      <div className="pn-modal__icon pn-modal__icon--warning">
        <Icon name="warning" size={50} />
      </div>
      <h2 className="pn-modal__heading">{title}</h2>
      {message ? <p className="pn-modal__subtitle">{message}</p> : null}
    </div>
  </Modal>
);

export default ConfirmModal;
